<template>
  <generic-modal :title="$t('account details')" ref="generic_modal">
    <div>
      <div class="title is-5">{{ member.name }}</div>
      <div
        class="subtitle is-5"
        v-if="member.account"
        v-bind:class="{
          'has-text-primary': Number(member.account.balance) >= 0,
          'has-text-danger': Number(member.account.balance) < 0,
        }"
      >
        {{ $t("balance") }}:
        {{ format_currency(member.account.balance) }}
      </div>
      <table
        class="table is-fullwidth"
        v-if="
          meta.account &&
          meta.account.account_movements.sort(
            (a, b) => new Date(b.create_date) - new Date(a.create_date)
          ).length
        "
      >
        <thead>
          <tr>
            <th>{{ $t("date") }}</th>
            <th>{{ $t("movement") }}</th>
            <th>{{ $t("amount") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="movement in meta.account.account_movements">
            <td>{{ format_date(movement.create_date) }}</td>
            <td>
              <span class="icon">
                <i
                  class="fa"
                  v-bind:class="{
                    'fa-angle-left has-text-danger':
                      movement.movement_type.behavior == 'charge',
                    'fa-angle-right has-text-success':
                      movement.movement_type.behavior == 'credit',
                  }"
                ></i>
              </span>
              {{ movement.movement_type.name }}
            </td>
            <td>{{ format_currency(movement.amount) }}</td>
          </tr>
        </tbody>
      </table>
      <!-- <pre>{{ meta }}</pre> -->
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  format_date,
  generate_error_message_text,
  get_currency_settings,
  format_currency,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "AccountModal",
  components: { GenericModal },
  data() {
    return {
      member: {},
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.amount || isNaN(v.meta.amount);
    },
  },
  methods: {
    format_date,
    format_currency,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(member) {
      let v = this;
      v.set_initial_state();
      v.member = member;
      get("/gym_member/account", { uuid: member.uuid })
        .then((response) => {
          v.meta = response;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      put("/gym_member/payment", v.meta)
        .then(() => {
          v.$emit("success");
          v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.member = {};
      v.meta = {
        name: "",
        gym_member_id: "",
        amount: "",
        settings: {},
      };
      v.error = "";
      // v.uuid = "";
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
